export const AcceptedFileTypes = {
  ALL: '.jpg, .jpeg, .png, .gif, .mpeg, .mpeg-1, .mpeg-2, .mpeg4, .mp4, .mpg, .mov, .pdf, .mp3, .docx, .pptx, .html',
  IMAGE: '.jpg, .jpeg, .png',
  VIDEO: '.mp4, .mov, .ogg, .webm',
};
